import { CommentFormState } from '../hooks/useCommentEditorForm';
import { CANtrackComment } from '../types/comment';

function getUpdatedCommentFromFormState(
	formState: CommentFormState,
	comment?: CANtrackComment,
	userId?: string,
	contactId?: string,
): CANtrackComment {
	// Implement the logic to convert the form state to a Comment object
	if (!formState.selectedCase) throw new Error('No case selected');
	if (!formState.selectedActivity) throw new Error('No activity selected');
	const updatedComment: CANtrackComment = {
		id: comment ? comment.id : 0,
		title: formState.title,
		description: formState.description,
		date: formState.entryDate,
		timeRegular: formState.time.regularTime,
		timeOver: formState.time.overTime,
		caseID: formState.selectedCase.id,
		caseTitle: formState.selectedCase.title,
		customerID: formState.selectedCase.customerID,
		customerName: formState.selectedCase.customerName,
		gpda: {
			group: formState.selectedCase.gpd.group,
			project: formState.selectedCase.gpd.project,
			deliverable: formState.selectedCase.gpd.deliverable,
			activity: {
				id: parseInt(formState.selectedActivity.Id),
				title: formState.selectedActivity.Title,
			},
		},
		billable: formState.billable,
	};
	if (userId && contactId) {
		updatedComment.userId = userId;
		updatedComment.contactId = contactId;
	}

	return updatedComment;
}

export default getUpdatedCommentFromFormState;
